
const EventBusClass = function () {
  this.listeners = {};
  this.appName = '';
};

EventBusClass.prototype = {
  setAppName(name) {
    this.appName = name;
	},	
	addGlobalEventListener:function(type, callback,scope){
		let orgName = this.appName
		this.appName = 'global';
		this.addEventListener(type,callback,scope)
		this.appName = orgName;
	},
	
  dispatchGlobal(type) {
		let orgName = this.appName
		this.appName = 'global';
		this.dispatch(...arguments)
		this.appName = orgName;
	},
	removeGlobalEventListener:function(type,callback,scope){
		let orgName = this.appName
		this.appName = 'global';
		this.removeEventListener(type,callback,scope)
		this.appName = orgName;
	},
  clearEventListener(appName) {
    if (appName !== this.appName) {
      return false;
    }
    this.listeners[this.appName] = undefined;
  },
  addEventListener(type, callback, scope) {
    if (!this.appName) {
      return false;
    }
    let args = [];
    const numOfArgs = arguments.length;
    for (let i = 0; i < numOfArgs; i++) {
      args.push(arguments[i]);
    }
    args = args.length > 3 ? args.splice(3, args.length - 1) : [];
    const listener = this.listeners[this.appName] || (this.listeners[this.appName] = {});
    if (typeof listener[type] !== 'undefined') {
      listener[type].push({ scope, callback, args });
    } else {
      listener[type] = [{ scope, callback, args }];
    }
  },
  removeEventListener(type, callback, scope) {
    if (!this.appName) {
      return false;
    }
    const typeListeners = this.listeners[this.appName] && this.listeners[this.appName][type];
    if (typeListeners) {
      const numOfCallbacks = typeListeners.length;
      const newArray = [];
      for (let i = 0; i < numOfCallbacks; i++) {
        const listener = typeListeners[i];
        if (listener.scope == scope && listener.callback == callback) {

        } else {
          newArray.push(listener);
        }
      }
      this.listeners[this.appName][type] = newArray;
    }
  },
  dispatch(type) {
    if (!this.appName) {
      return false;
    }
    const event = {
      type,
    };
    let args = [];
    const numOfArgs = arguments.length;
    for (let i = 0; i < numOfArgs; i++) {
      args.push(arguments[i]);
    };
    args = args.length > 1 ? args.splice(1, args.length - 1) : [];
    args = [event].concat(args);

    for (const appName in this.listeners) {
      const appListeners = this.listeners[appName];
      const typeListeners = appListeners && appListeners[type];

      if (typeListeners) {
        const listeners = typeListeners.slice();
        const numOfCallbacks = listeners.length;
        for (let i = 0; i < numOfCallbacks; i++) {
          const listener = listeners[i];
          if (listener && listener.callback) {
            const concatArgs = args.concat(listener.args);
            listener.callback.apply(listener.scope, concatArgs);
          }
        }
      }
    }
  },
};

const TNBL = window.TNBL || (window.TNBL = {});
TNBL.eventBus = new EventBusClass();
